import React, { useState } from "react";
import { DelayInput } from "react-delay-input/lib/Component";
import DefaultButton from "../../../styles/materialButtonStyle";
import FeeTypeSelect from "../../../elements/fee/FeeTypeSelect";
import Dropdown from "rc-dropdown";
import MappedServicesFilter from "../../../elements/serviceReletionships/mappedServices/MappedServicesFilter";
import { useTranslation } from "react-i18next";

import {
  StyledFilterBlock,
  StyledFilterBlockTitle,
  StyledFilterCloseBtn,
  StyledFilterDropdownWrapper,
  StyledFilterGroup,
  StyledFilterWrapper,
  StyledSelectGroup,
  StyledShowFilterBtn
} from "../../../elements/filter/styledFiter";

const RangeFeeFilter = ({ filterData, setFilterData }) => {
  const { t } = useTranslation("clientsPage");

  const DEFAULT_FILTER_DATA = {
    "page": 1,
    "itemsPerPage": filterData["itemsPerPage"] ?? null,
    "currentTab": filterData["currentTab"],
    "percent[gte]": "",
    "percent[lte]": "",
    "constant[gte]": "",
    "constant[lte]": "",
    "minAmount[gte]": "",
    "minAmount[lte]": ""
  };

  const [visible, setVisible] = useState(false);

  const onVisibleChange = (visible) => {
    setVisible(visible);
  };

  const handleClearFilter = () => {
    setFilterData(DEFAULT_FILTER_DATA);
  };

  const handleChangeFilterData = (data, name) => {
    setFilterData(prev => ({
      ...prev,
      [name]: data,
      page: 1
    }))
  };

  const FilterList = () => {
    return (
      <>
        {visible &&
        <StyledFilterDropdownWrapper>
          <StyledFilterBlock actions>
            <StyledFilterGroup className="clear-btn">
              <DefaultButton
                color="transparent"
                onClick={handleClearFilter}
              >
                {t("details.rangeFee.filter.clearBtn")}
              </DefaultButton>
            </StyledFilterGroup>
            <StyledFilterGroup className="close-btn">
              <StyledFilterCloseBtn onClick={() => setVisible(false)} />
            </StyledFilterGroup>
          </StyledFilterBlock>
          <StyledFilterBlockTitle>
            {t("details.rangeFee.filter.paymentMethod")}:
          </StyledFilterBlockTitle>
          <StyledFilterBlock col="2">
            <MappedServicesFilter
              checkedService={filterData["baseFee.service.name"]}
              setCheckedService={data => handleChangeFilterData(data, "baseFee.service.name")}

              checkedPaymentSystem={filterData["baseFee.paymentSystem.name"]}
              setCheckedPaymentSystem={data => handleChangeFilterData(data, "baseFee.paymentSystem.name")}

              checkedCurrency={filterData["baseFee.currency.asset"]}
              setCheckedCurrency={data => handleChangeFilterData(data, "baseFee.currency.asset")}
            />
            <StyledSelectGroup>
              <FeeTypeSelect
                checkedType={filterData["baseFee.type"]}
                setCheckedType={(data) => setFilterData({ ...filterData, "baseFee.type": data, page: 1 })}
                defaultOption={true}
              />
            </StyledSelectGroup>
          </StyledFilterBlock>
          <StyledFilterBlockTitle>
            {t("details.rangeFee.filter.percent")}:
          </StyledFilterBlockTitle>
          <StyledFilterBlock col="2">
            <StyledFilterGroup>
              <label htmlFor="percent[gte]">
                {t("details.rangeFee.filter.percentFrom")}
              </label>
              <DelayInput
                id="percent[gte]"
                delayTimeout={2000}
                onChange={event => setFilterData({ ...filterData, "percent[gte]": event.target.value, page: 1 })}
                name="percent[gte]"
                value={filterData["percent[gte]"]}
                type="number"
                step={0.1}
                min={0}
                max={1}
              />
            </StyledFilterGroup>
            <StyledFilterGroup>
              <label htmlFor="percent[lte]">
                {t("details.rangeFee.filter.percentTo")}
              </label>
              <DelayInput
                id="percent[lte]"
                delayTimeout={2000}
                onChange={event => setFilterData({ ...filterData, "percent[lte]": event.target.value, page: 1 })}
                name="percent[lte]"
                value={filterData["percent[lte]"]}
                type="number"
                step={0.1}
                min={0}
                max={1}
              />
            </StyledFilterGroup>
          </StyledFilterBlock>
          <StyledFilterBlockTitle>
            {t("details.rangeFee.filter.constant")}:
          </StyledFilterBlockTitle>
          <StyledFilterBlock col="2">
            <StyledFilterGroup>
              <label htmlFor="constant[gte]">
                {t("details.rangeFee.filter.constantFrom")}
              </label>
              <DelayInput
                id="constant[gte]"
                delayTimeout={2000}
                onChange={event => setFilterData({ ...filterData, "constant[gte]": event.target.value, page: 1 })}
                name="constant[gte]"
                value={filterData["constant[gte]"]}
                type="number"
                placeholder={t("details.rangeFee.filter.example", { value: 20 })}
              />
            </StyledFilterGroup>
            <StyledFilterGroup>
              <label htmlFor="constant[lte]">
                {t("details.rangeFee.filter.constantTo")}
              </label>
              <DelayInput
                id="constant[lte]"
                delayTimeout={2000}
                onChange={event => setFilterData({ ...filterData, "constant[lte]": event.target.value, page: 1 })}
                name="constant[lte]"
                value={filterData["constant[lte]"]}
                type="number"
                placeholder={t("details.rangeFee.filter.example", { value: 200 })}
              />
            </StyledFilterGroup>
          </StyledFilterBlock>
          <StyledFilterBlockTitle>
            {t("details.rangeFee.filter.min")}:
          </StyledFilterBlockTitle>
          <StyledFilterBlock col="2">
            <StyledFilterGroup>
              <label htmlFor="minAmount[gte]">
                {t("details.rangeFee.filter.minFrom")}
              </label>
              <DelayInput
                id="minAmount[gte]"
                delayTimeout={2000}
                onChange={event => setFilterData({ ...filterData, "minAmount[gte]": event.target.value, page: 1 })}
                name="minAmount[gte]"
                value={filterData["minAmount[gte]"]}
                type="number"
                placeholder={t("details.rangeFee.filter.example", { value: 20 })}
              />
            </StyledFilterGroup>
            <StyledFilterGroup>
              <label htmlFor="min[lte]">
                {t("details.rangeFee.filter.minTo")}
              </label>
              <DelayInput
                id="minAmount[lte]"
                delayTimeout={2000}
                onChange={event => setFilterData({ ...filterData, "minAmount[lte]": event.target.value, page: 1 })}
                name="minAmount[lte]"
                value={filterData["minAmount[lte]"]}
                type="number"
                placeholder={t("details.rangeFee.filter.example", { value: 200 })}
              />
            </StyledFilterGroup>
          </StyledFilterBlock>
        </StyledFilterDropdownWrapper>}
      </>
    );
  };

  return (
    <StyledFilterWrapper id="filter">
      <Dropdown
        getPopupContainer={() => document.getElementById("filter")}
        overlay={FilterList}
        trigger={["click"]}
        placement="bottomLeft"
        align={{ overflow: { adjustX: true, adjustY: false } }}
        onVisibleChange={onVisibleChange}
        visible={visible}
        closeOnSelect={false}
      >
        <StyledShowFilterBtn>
          <DefaultButton
            color="success"
          >
            {t("details.rangeFee.filter.filterBtn")}
          </DefaultButton>
        </StyledShowFilterBtn>
      </Dropdown>
    </StyledFilterWrapper>
  );
};

export default RangeFeeFilter;